import { render } from "./FooterNav.vue?vue&type=template&id=20885a86&scoped=true"
import script from "./FooterNav.vue?vue&type=script&lang=js"
export * from "./FooterNav.vue?vue&type=script&lang=js"

import "./FooterNav.vue?vue&type=style&index=0&id=20885a86&scoped=true&lang=css"

import exportComponent from "/Users/ezink/Downloads/vue-antd-tool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20885a86"]])

export default __exports__